export const mask = {
  maskOikCode: {
    regex: "[a-zA-z0-9][^\\[\\]]{1,}",
    placeholder: "",
  },
};
